import { useMerchant } from 'hooks/useGlobalContext/useMerchant'
import React, { useEffect, useState } from 'react'
import { LoaderProps } from './types'
import { useSession } from 'packages/@slerp/accounts'
import { useQuery } from '@apollo/client'
import { QUERY_STRIPE_CONNECT_URL } from 'router/queries'
import { STRIPE_CONNECT_OAUTH_ENDPOINT } from '@slerp/client'
import { StripeConnectData } from '@slerp/controls'

const redirect_uri = STRIPE_CONNECT_OAUTH_ENDPOINT

export const StripeConnectLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const {
    stripeConnectData,
    setStripeConnectData,
    setRefetchStripeConnectData
  } = useMerchant()
  const { merchant } = useSession()

  const [isLoaded, setIsLoaded] = useState(false)

  const { loading, refetch } = useQuery<{
    stripeConnectUrl: StripeConnectData
  }>(QUERY_STRIPE_CONNECT_URL, {
    variables: {
      redirectUri: redirect_uri,
      merchantId: merchant?.id
    },
    fetchPolicy: 'no-cache',
    skip: !merchant?.id || !!stripeConnectData,
    onCompleted: (data) => {
      if (!data?.stripeConnectUrl) {
        return
      }
      setStripeConnectData(data.stripeConnectUrl)
    }
  })

  useEffect(() => {
    if (!refetch) {
      return
    }
    setRefetchStripeConnectData(() => refetch)
  }, [refetch])

  useEffect(() => {
    setIsLoaded(isParentLoaded && !loading)
  }, [loading, isParentLoaded])

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
